

let yesText = 'Ano';
let noText = 'Ne';

export function setBooleanTexts(yes, no) {
	yesText = yes;
	noText = no;
}


export function formatBoolean(value) {
	if (value === true || value === 1 || value === 'Y' || value === 'T') {
		return yesText;
	} else if (value === false || value === 0 || value === 'N' || value === 'F') {
		return noText;
	}
	return '';
}
